export const PAGE_SIZE = 25;
export const SAVED_LIST_PAGE_SIZE = 10;
export const maxNumberOfRecords = 10000;
export const selectedViewTypes = {
  "all-patients": { title: "AllPatients", description: "All Patients" },
  "visit-schedule": { title: "VisitSchedule", description: "Visit Schedule" },
  "pending-renewal": { title: "PendingRenewal", description: "Pending Renewals" },
  "high-priority": { title: "HighPriorities", description: "High Priority" },
  "saved-list": { title: "SavedList", description: "Saved Lists" },
  "all-applications": { title: "AllApplications", description: "All Enrollments" },
  "all-claims": { title: "AllClaims", description: "All Claims" }
};

export const selectedViews = {
  allPatients: "all-patients",
  visitSchedule: "visit-schedule",
  pendingRenewal: "pending-renewal",
  highPriority: "high-priority",
  topOpportunity: "top-opportunity",
  savedList: "saved-list",
  allApplications: "all-applications",
  claims: "claims",
  allClaims: "all-claims"
};
